import { render, staticRenderFns } from "./IcoTrophy.vue?vue&type=template&id=9fec0b9e"
import script from "./IcoTrophy.vue?vue&type=script&lang=js"
export * from "./IcoTrophy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports